import { ReactNode } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { CoreIconButton } from "@verity/components/core";
import i18n from "../../i18n";
import styles from "./back-banner.module.css";
import ArrowLeft from "../../images/arrow-left.svg?react";

export default function BackBanner({ onBack, children }: { onBack: () => void; children: ReactNode }) {
	return (
		<div className={styles.selectedAssessmentBanner}>
			<CoreIconButton variant="plain" onClick={onBack} tooltip={i18n.t("portal.components.backBannerTSX.back")}>
				<SvgIcon>
					<ArrowLeft />
				</SvgIcon>
			</CoreIconButton>
			{children}
		</div>
	);
}
